/* eslint-disable @next/next/no-img-element */
import dynamic from 'next/dynamic';

import React, { Fragment, useEffect, useState } from "react";
import { SwiperSlide } from "swiper/react";
import { client } from "@/utils/sanity";

const Button = dynamic(() => import('@/components/ui/Button'));
const LogoLoading = dynamic(() => import('@/components/ui/LogoLoading'));
const VideoBanner = dynamic(() => import('@/components/new/general/VideoBanner'), { ssr: false });

export default function GamesPageVideoBanner() {
  const [games, setGames] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const fetchedGames = await client.fetch(`*[_type == "banner"]`);
        setGames(fetchedGames);
      } catch (error) {
        console.error("Error fetching games:", error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchData();
  }, []);

  const LoadingPlaceholder = () => (
    <div
      className="loading-placeholder-responsive-carousel"
      style={{
        backgroundColor: "transparent",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <LogoLoading />
    </div>
  );

  return (
    <Fragment>
      {isLoading ? (
        <LoadingPlaceholder />
      ) : (
        <VideoBanner>
          {games.map((game, index) => (
            <SwiperSlide key={index}>
              <div
                className={`swiperSlideDiv relative w-full transition-transform duration-[600ms] ease-in-out`}>
                {game.banner &&
                (game.banner.url.includes(".m4v") ||
                  game.banner.url.includes(".mp4")) ? (
                  <video
                    className="background-video object-cover w-full h-full"
                    loading="lazy"
                    src={game.banner.url}
                    loop
                    muted
                    autoPlay={true}
                    playsInline
                  />
                ) : (
                  <img
                    alt=""
                    src={game.banner.url}
                    className="object-cover w-full h-auto"
                  />
                )}
                <div className="absolute !pr-8 !pl-8 xl:container inset-x-[8%] 2xl:inset-x-[0%] block pt-4 pb-4 md:pb-24 text-left text-white  top-1/2 transform -translate-y-1/2">
                  <h4 className="text-3xl font-bold text-white text-left gameHeader leading-tight">
                    {game.header}
                  </h4>
                  <p className="text-sm text-left md:mt-8 mt-4">
                    {game.description}
                  </p>
                </div>

                <div
                  className={`!z-[999] md:flex md:inset-x-[8%] !pr-8 !pl-8 xl:container  2xl:inset-x-[0%] w-full md:w-auto absolute bottom-4 md:bottom-16 py-4 md:py-8`}>
                  <a
                    href={
                      game.buttonlink && game.buttonlink.url
                        ? game.buttonlink.url
                        : "#"
                    }
                    target={
                      game.buttonlink.url === "https://www.metaxseed.io/nodes"
                        ? "_self"
                        : "_blank"
                    }
                    className="flex space-x-4 !z-[999] justify-start items-center rtl:space-x-reverse">
                    <Button
                      icon="iconamoon:arrow-right-6-circle-fill"
                      text={game.button}
                      className={`!z-[999] hover:jello-horizontal h-min text-md md:w-auto md:min-w-64 w-full md:text-base font-normal text-zinc-50 shadow-lg bg-metaxseed-blue px-8`}
                      iconClassName="text-lg"
                    />
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </VideoBanner>
      )}
    </Fragment>
  );
}
